import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { STALE_TIME_MEDIUM } from "../queries/query.constants";
import { useQuery } from "@tanstack/vue-query";
const FEATURE_FLAGS_STALE_TIME = STALE_TIME_MEDIUM;
export function useFeatureFlags() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["feature-flags"],
        queryFn: async () => (await seedgreenAPI.get("v2/FeatureFlag/Me")).data,
        staleTime: FEATURE_FLAGS_STALE_TIME,
    });
    return {
        featureFlags: query.data,
        ...query,
    };
}
